import React, { useEffect } from "react";
import { Route, Switch, BrowserRouter, useLocation, HashRouter } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import App from "../App";
import AOSInit from "./AOSInit";
import Clustercloudelasticsearch from "../../detailspage/Page/cluster-cloud-elastic-search";
import Clusterkafka from "../../detailspage/Page/cluster-kafka";
import Clustercloudrabbitmq from "../../detailspage/Page/cluster-cloud-rabbitmq";
import Clustercloudmysqldb from "../../detailspage/Page/cluster-cloud-mysql-db";
import Clustercloudpostgresqldb from "../../detailspage/Page/cluster-cloud-postgresql-db";
import Clustercloudvitess from "../../detailspage/Page/cluster-cloud-vitess";
import Clustercloudmongodb from "../../detailspage/Page/cluster-cloud-mongodb";
import Clustercloudredis from "../../detailspage/Page/cluster-cloud-redis";
import Clustercloudscylladb from "../../detailspage/Page/cluster-cloud-scylladb";
import Clusterclickhouse from "../../detailspage/Page/cluster-clickhouse";
import Storeblockstore from "../../detailspage/Page/store-block-store";
import Storenasstore from "../../detailspage/Page/store-nas-store";
import Storeobjectstore from "../../detailspage/Page/store-object-store";
import Computeautoscale from "../../detailspage/Page/compute-auto-scale";
import Computebaremetal from "../../detailspage/Page/compute-bare-metal";
import Computedatabase from "../../detailspage/Page/compute-database";
import Computevps from "../../detailspage/Page/compute-vps";
import Computems from "../../detailspage/Page/compute-ms";
import Computeloadbalance from "../../detailspage/Page/compute-load-balance";
import MSA1 from "../../microservice/container/msa-1";
import MSA2 from "../../microservice/container/msa-2";
import data from '../../../package.json'
import MSA from "../../microservice/demo/microservice/container/msa-1";
import WebHook from "../../microservice/container/webhook";
import Iaam from "../../microservice/container/iaam";
import LongRunning from "../../microservice/container/long-running";
import SimpleStorage from "../../microservice/container/simple-storage";
import SimpleUrl from "../../microservice/container/simple-url";
import EventSourcing from "../../microservice/container/event-sourcing";
import MSA3 from "../../microservice/container/msa3";
import OutSourcing from "../../outsourcing/container/outsourcing";
import MessagingService from "../../microservice/container/messaging-service";
import ClusterClickHouseTest from "../../detailspage/Page/cluster-clickhouse-test";
import KubernetesDemo from "../../kubernetes/kubernetes-demo";
import Kubernetes from "../../kubernetes/kubernetes";
import IndexKo from "../../hanbiropage/index-ko";
import IndexVi from "../../hanbiropage/index-vi";
import HelpDesk from "../../hanbiropage/helpdesk/help-desk";
import CrmCall from "../../hanbiropage/crmcall/crm-call";
import IndexDemo from "../../hanbiropage/index-demo";
import IndexPage from "../../hanbiropage/index-page";
import IndexPage1 from "../../hanbiropage/index-page1";
import IndexPage2 from "../../hanbiropage/index-page2";
import MonitoringVolume from "../../detailspage/Page/kube-monitoring-volume";
import BackOffice from "../../detailspage/Page/kube-back-office";
import Soho from "../../detailspage/Page/kube-soho";
import Scalable from "../../detailspage/Page/kube-scalable";
import Enterprise from "../../detailspage/Page/kube-enterprise";
import KubeBenefits from "../../detailspage/Page/kube-benefits";
import IndexDemoModal from "../../hanbiropage/index-demo-modal";
import GlobalPage from "../../hanbiroglobal/global-page";
import GlobalPage1 from "../../hanbiroglobal/global-page1";
import GlobalPage2 from "../../hanbiroglobal/global-page2";
import PageRegistration from "../../hanbiropage/page-registration";
import IndexVietnamese from "../../hanbiropage/index-vietnamese";
import HanbiroVn from "../../hanbirovn/hanbirovn";
import KubeBenefitsVN from "../../detailpageVN/Page/kube-benefits-vn";
import ClustercloudelasticsearchVN from "../../detailpageVN/Page/cluster-cloud-elastic-search-vn";
import ClusterkafkaVN from "../../detailpageVN/Page/cluster-kafka-vn";
import ClustercloudmysqldbVN from "../../detailpageVN/Page/cluster-cloud-mysql-db-vn"
import ClustercloudpostgresqldbVN from "../../detailpageVN/Page/cluster-cloud-postgresql-db-vn"
import ClustercloudvitessVN from "../../detailpageVN/Page/cluster-cloud-vitess-vn"
import ClustercloudmongodbVN from "../../detailpageVN/Page/cluster-cloud-mongodb-vn"
import ClustercloudredisVN from "../../detailpageVN/Page//cluster-cloud-redis-vn"
import ClustercloudscylladbVN from "../../detailpageVN/Page//cluster-cloud-scylladb-vn"
import ClusterclickhouseVN from "../../detailpageVN/Page//cluster-clickhouse-vn"

import SohoVN from "../../detailpageVN/Page/kube-soho-vn";
import ScalableVN from "../../detailpageVN/Page/kube-scalable-vn";
import EnterpriseVN from "../../detailpageVN/Page/kube-enterprise-vn";
import MonitoringVolumeVN from "../../detailpageVN/Page/kube-monitoring-volume-vn";
import MSA2VN from "../../detailpageVN/Page/msa-2-vn";
import MSA3VN from "../../detailpageVN/Page/msa3-vn";
import IaamVN from "../../detailpageVN/Page/iaam-vn";
import EventSourcingVN from "../../detailpageVN/Page/event-sourcing-vn";
import WebHookVN from "../../detailpageVN/Page/webhook-vn";
import LongRunningVN from "../../detailpageVN/Page/long-running-vn";
import SimpleUrlVN from "../../detailpageVN/Page/simple-url-vn";
import SimpleStorageVN from "../../detailpageVN/Page/simple-storage-vn";
import MessagingServiceVN from "../../detailpageVN/Page/messaging-service-vn";
import HanbiroEn from "../../hanbirovn/hanbiroen";

import KubeBenefitsENG from "../../detailpageEng/Page/kube-benefits-en";
import SohoENG from "../../detailpageEng/Page/kube-soho-en";
import ScalableENG from "../../detailpageEng/Page/kube-scalable-en";
import EnterpriseENG from "../../detailpageEng/Page/kube-enterprise-en";
import MonitoringVolumeENG from "../../detailpageEng/Page/kube-monitoring-volume-en";
import ClustercloudelasticsearchENG from "../../detailpageEng/Page/cluster-cloud-elastic-search-en";
import ClusterkafkaENG from "../../detailpageEng/Page/cluster-kafka-en";
import ClustercloudmysqldbENG from "../../detailpageEng/Page/cluster-cloud-mysql-db-en"
import ClustercloudpostgresqldbENG from "../../detailpageEng/Page/cluster-cloud-postgresql-db-en"
import ClustercloudvitessENG from "../../detailpageEng/Page/cluster-cloud-vitess-en"
import ClustercloudmongodbENG from "../../detailpageEng/Page/cluster-cloud-mongodb-en"
import ClustercloudredisENG from "../../detailpageEng/Page/cluster-cloud-redis-en"
import ClustercloudscylladbENG from "../../detailpageEng/Page/cluster-cloud-scylladb-en"
import ClusterclickhouseENG from "../../detailpageEng/Page/cluster-clickhouse-en"
import MSA2ENG from "../../detailpageEng/Page/msa-2-en";
import MSA3ENG from "../../detailpageEng/Page/msa3-en";
import IaamENG from "../../detailpageEng/Page/iaam-en";
import MessagingServiceENG from "../../detailpageEng/Page/messaging-service-en";
import EventSourcingENG from "../../detailpageEng/Page/event-sourcing-en";
import WebHookENG from "../../detailpageEng/Page/webhook-en";
import LongRunningENG from "../../detailpageEng/Page/long-running-en";
import SimpleUrlENG from "../../detailpageEng/Page/simple-url-en";
import SimpleStorageENG from "../../detailpageEng/Page/simple-storage-en";


const RouteQaCloud = () => {
  return (

    <HashRouter>
      <AOSInit />
      <Switch>
        <Route exact path="/" component={IndexPage2} />
        {/* <Route exact path="/" component={IndexDemoModal} /> */}
        {/* <Route exact path="/cloud" component={App} /> */}
        <Route exact path={data.homepage} component={IndexPage2} />
        <Route exact path='/cloud-service' component={App} />
        <Route exact path="/cloud/msa1" component={MSA1} />
        {/* Cloud */}
        <Route exact path="/application" component={Clustercloudelasticsearch} />
        <Route exact path="/application/cluster-cloud-elastic-search" component={Clustercloudelasticsearch} />
        <Route exact path="/application/cluster-kafka" component={Clusterkafka} />
        <Route exact path="/application/cluster-cloud-rabbitmq" component={Clustercloudrabbitmq} />
        <Route exact path="/application/cluster-cloud-mysql-db" component={Clustercloudmysqldb} />
        <Route exact path="/application/cluster-cloud-postgresql-db" component={Clustercloudpostgresqldb} />
        <Route exact path="/application/cluster-cloud-vitess" component={Clustercloudvitess} />
        <Route exact path="/application/cluster-cloud-mongodb" component={Clustercloudmongodb} />
        <Route exact path="/application/cluster-cloud-redis" component={Clustercloudredis} />
        <Route exact path="/application/cluster-cloud-scylladb" component={Clustercloudscylladb} />
        <Route exact path="/application/cluster-clickhouse" component={Clusterclickhouse} />
        {/* ----------- */}
        {/* Storage */}
        <Route exact path="/store-object-store" component={Storeobjectstore} />
        <Route exact path="/store-block-store" component={Storeblockstore} />
        <Route exact path="/store-nas-store" component={Storenasstore} />
        {/* ----------- */}
        {/* Compute */}
        <Route exact path="/compute-vps" component={Computevps} />
        <Route exact path="/compute-bare-metal" component={Computebaremetal} />
        <Route exact path="/compute-auto-scale" component={Computeautoscale} />
        <Route exact path="/compute-load-balance" component={Computeloadbalance} />
        <Route exact path="/compute-ms" component={Computems} />
        <Route exact path="/compute-database" component={Computedatabase} />
        {/* ----------- */}
        {/* Microservice */}
        <Route exact path="/msa" component={MSA1} />
        <Route exact path="/msa1" component={MSA1} />
        <Route exact path="/msa2" component={MSA2} />
        <Route exact path="/msa3" component={MSA3} />
        <Route exact path="/msa3/iaam" component={Iaam} />
        <Route exact path="/msa3/event-sourcing" component={EventSourcing} />
        <Route exact path="/msa3/webhook" component={WebHook} />
        <Route exact path="/msa3/long-running" component={LongRunning} />
        <Route exact path="/msa3/simple-url-shortener" component={SimpleUrl} />
        <Route exact path="/msa3/simple-storage-service" component={SimpleStorage} />
        <Route exact path="/msa3/messaging-service" component={MessagingService} />

        {/* Private Kubernetes */}
        <Route exact path="/monitor" component={MonitoringVolume} />
        <Route exact path="/monitor/monitoring-volume" component={MonitoringVolume} />
        <Route exact path="/back-office" component={BackOffice} />
        <Route exact path="/soho" component={Soho} />
        <Route exact path="/soho/soho1" component={Soho} />
        <Route exact path="/soho/scalable" component={Scalable} />
        <Route exact path="/soho/enterprise" component={Enterprise} />
        <Route exact path="/private-cloud" component={KubeBenefits} />

        {/* Demo Language */}
        <Route path="/msa4" component={MSA} />
        <Route path="/outsourcing" component={OutSourcing} />
        <Route path="/demo" component={ClusterClickHouseTest} />
        <Route path="/kubernetes" component={Kubernetes} />
        <Route path="/kubernetes-demo" component={KubernetesDemo} />
        <Route path="/index-ko" component={IndexKo} />
        <Route path="/index-vi" component={IndexVi} />
        <Route path="/helpdesk" component={HelpDesk} />
        <Route path="/crmcall" component={CrmCall} />
        <Route path="/indexdemo" component={IndexDemo} />
        <Route path="/indexpage" component={IndexPage} />
        <Route path="/indexpage1" component={IndexPage1} />
        <Route path="/index" component={IndexPage2} />
        <Route path="/index" component={IndexDemoModal} />
        <Route path="/pageregistration" component={PageRegistration} />
        <Route path="/30-free-trial" component={PageRegistration} />

        <Route path="/globalpage" component={GlobalPage} />
        <Route path="/globalpage1" component={GlobalPage1} />
        <Route path="/hanbiro-global" component={GlobalPage2} />
        {/* Translate */}
        <Route path="/index-vietnamese" component={IndexVietnamese} />
        <Route path="/hanbiro-vn" component={HanbiroVn} />
        <Route path="/en/home" component={HanbiroEn} />

        <Route exact path="/vi/private-cloud" component={KubeBenefitsVN} />
        <Route exact path="/vi/private-cloud/soho" component={SohoVN} />
        <Route exact path="/vi/private-cloud/soho/soho1" component={SohoVN} />
        <Route exact path="/vi/private-cloud/soho/scalable" component={ScalableVN} />
        <Route exact path="/vi/private-cloud/soho/enterprise" component={EnterpriseVN} />
        <Route exact path="/vi/private-cloud/monitor" component={MonitoringVolumeVN} />
        <Route exact path="/vi/private-cloud/monitor/monitoring-volume" component={MonitoringVolumeVN} />
        <Route exact path="/vi/private-cloud/application" component={ClustercloudelasticsearchVN} />
        <Route exact path="/vi/private-cloud/application/cluster-cloud-elastic-search" component={ClustercloudelasticsearchVN} />
        <Route exact path="/vi/private-cloud/application/cluster-kafka" component={ClusterkafkaVN} />
        <Route exact path="/vi/private-cloud/application/cluster-cloud-mysql-db" component={ClustercloudmysqldbVN} />
        <Route exact path="/vi/private-cloud/application/cluster-cloud-postgresql-db" component={ClustercloudpostgresqldbVN} />
        <Route exact path="/vi/private-cloud/application/cluster-cloud-vitess" component={ClustercloudvitessVN} />
        <Route exact path="/vi/private-cloud/application/cluster-cloud-mongodb" component={ClustercloudmongodbVN} />
        <Route exact path="/vi/private-cloud/application/cluster-cloud-redis" component={ClustercloudredisVN} />
        <Route exact path="/vi/private-cloud/application/cluster-cloud-scylladb" component={ClustercloudscylladbVN} />
        <Route exact path="/vi/private-cloud/application/cluster-clickhouse" component={ClusterclickhouseVN} />

        <Route exact path="/vi/private-cloud/msa2" component={MSA2VN} />
        <Route exact path="/vi/private-cloud/msa3" component={MSA3VN} />
        <Route exact path="/vi/private-cloud/msa3/iaam" component={IaamVN} />
        <Route exact path="/vi/private-cloud/msa3/messaging-service" component={MessagingServiceVN} />
        <Route exact path="/vi/private-cloud/msa3/event-sourcing" component={EventSourcingVN} />
        <Route exact path="/vi/private-cloud/msa3/webhook" component={WebHookVN} />
        <Route exact path="/vi/private-cloud/msa3/long-running" component={LongRunningVN} />
        <Route exact path="/vi/private-cloud/msa3/simple-url-shortener" component={SimpleUrlVN} />
        <Route exact path="/vi/private-cloud/msa3/simple-storage-service" component={SimpleStorageVN} />

        <Route exact path="/en/private-cloud" component={KubeBenefitsENG} />
        <Route exact path="/en/private-cloud/soho" component={SohoENG} />
        <Route exact path="/en/private-cloud/soho/soho1" component={SohoENG} />
        <Route exact path="/en/private-cloud/soho/scalable" component={ScalableENG} />
        <Route exact path="/en/private-cloud/soho/enterprise" component={EnterpriseENG} />
        <Route exact path="/en/private-cloud/monitor" component={MonitoringVolumeENG} />
        <Route exact path="/en/private-cloud/monitor/monitoring-volume" component={MonitoringVolumeENG} />
        <Route exact path="/en/private-cloud/application" component={ClustercloudelasticsearchENG} />
        <Route exact path="/en/private-cloud/application/cluster-cloud-elastic-search" component={ClustercloudelasticsearchENG} />
        <Route exact path="/en/private-cloud/application/cluster-kafka" component={ClusterkafkaENG} />
        <Route exact path="/en/private-cloud/application/cluster-cloud-mysql-db" component={ClustercloudmysqldbENG} />
        <Route exact path="/en/private-cloud/application/cluster-cloud-postgresql-db" component={ClustercloudpostgresqldbENG} />
        <Route exact path="/en/private-cloud/application/cluster-cloud-vitess" component={ClustercloudvitessENG} />
        <Route exact path="/en/private-cloud/application/cluster-cloud-mongodb" component={ClustercloudmongodbENG} />
        <Route exact path="/en/private-cloud/application/cluster-cloud-redis" component={ClustercloudredisENG} />
        <Route exact path="/en/private-cloud/application/cluster-cloud-scylladb" component={ClustercloudscylladbENG} />
        <Route exact path="/en/private-cloud/application/cluster-clickhouse" component={ClusterclickhouseENG} />

        <Route exact path="/en/private-cloud/msa2" component={MSA2ENG} />
        <Route exact path="/en/private-cloud/msa3" component={MSA3ENG} />
        <Route exact path="/en/private-cloud/msa3/iaam" component={IaamENG} />
        <Route exact path="/en/private-cloud/msa3/messaging-service" component={MessagingServiceENG} />
        <Route exact path="/en/private-cloud/msa3/event-sourcing" component={EventSourcingENG} />
        <Route exact path="/en/private-cloud/msa3/webhook" component={WebHookENG} />
        <Route exact path="/en/private-cloud/msa3/long-running" component={LongRunningENG} />
        <Route exact path="/en/private-cloud/msa3/simple-url-shortener" component={SimpleUrlENG} />
        <Route exact path="/en/private-cloud/msa3/simple-storage-service" component={SimpleStorageENG} />


      </Switch>
    </HashRouter>

  )

};

export default RouteQaCloud;
